const SvgBigArrowRight = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
    <path d="M24 16 9.333 27.333V4.666L24 15.999z" />
  </svg>;
export default SvgBigArrowRight;